import 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.$ = window.jQuery = require('jquery');
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('bootstrap');
require('jquery-confirm');
require('jquery-validation');
require("jquery-ui/ui/widgets/sortable");
require("jquery-ui/ui/widgets/droppable");
require("jquery-ui/ui/widgets/draggable");
require('bootstrap-daterangepicker');
require('jquery.are-you-sure');
require('select2');
require('select2/dist/js/i18n/sl.js');
require('../../public/vendor/adminlte/dist/js/adminlte');
window.moment = require('moment');
window.tempusDominus = require('@eonasdan/tempus-dominus/dist/js/tempus-dominus.min');
